import React from "react";
import { withRouter } from "react-router-dom";
import { srmToCss } from "../../../../util/beercalc";
import "./BeerCard.scss";

const BeerCard = ({
  beer,
  editBeer,
  confirmBeerDeletion,
  brewBeer,
  history,
}) => {
  const routeToDetail = (e) => {
    if (e.defaultPrevented) return;
    history.push(`/beers/${beer.id}`);
  };

  // Default to 4 (pale yellow) if 0 so it's always visible against white background
  const beerColor = srmToCss(beer.srm || 4);

  // Format unknown recipes nicely
  const isUnknown = beer.name.toLowerCase().includes("unknown prod recipe");
  const displayName = isUnknown ? "Unknown Beer" : beer.name;
  const displayStyle = isUnknown
    ? `Recipe ${beer.name.match(/#(\d+)/)?.[0] || ""}`
    : beer.style?.name || "Unknown Style";

  return (
    <div className="beer-card" onClick={routeToDetail}>
      <div
        className="beer-card__color-strip"
        style={{ backgroundColor: beerColor }}
      />
      <div
        className="beer-card__wrapper"
        style={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <div className="beer-card__content">
          <div className="beer-card__header">
            <div className="beer-card__titles">
              <h3 className="beer-card__name">{displayName}</h3>
              <p className="beer-card__style">{displayStyle}</p>
            </div>
          </div>
          <div className="beer-card__specs">
            ABV {beer.abv || "0.0"}% &middot; IBU {beer.ibu || "0"} &middot; SRM{" "}
            {beer.srm || "0"}
            {beer.carbonation && (
              <span>
                {" "}
                &middot; {parseFloat(beer.carbonation).toFixed(2)} g/L CO2
              </span>
            )}
            {beer.is_shared && (
              <span className="beer-card__shared-badge">Shared</span>
            )}
          </div>
        </div>
        <div
          className="beer-card__actions-row"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="beer-card__action beer-card__action--delete"
            onClick={(e) => {
              e.stopPropagation();
              confirmBeerDeletion(beer.id);
            }}
          >
            <span className="ion-trash-a" /> Delete
          </button>
          <button
            className="beer-card__action beer-card__action--edit"
            onClick={(e) => {
              e.stopPropagation();
              editBeer(beer);
            }}
          >
            <span className="ion-edit" /> Edit
          </button>
          <button
            className="beer-card__action beer-card__action--brew"
            onClick={(e) => {
              e.stopPropagation();
              brewBeer(beer.id);
            }}
          >
            <span className="ion-waterdrop" /> Brew
          </button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(BeerCard);
